<template>
  <RevCardCarousel
    v-if="shouldDisplayBlock"
    class="[&_li]:rounded-lg [&_li]:w-[223px] [&_li]:bg-[url('/img/product/verified-refurbished/fingerprint.svg'),_url('/img/product/verified-refurbished/holo.avif')] [&_li]:bg-blend-overlay [&_li]:[background-attachment:scroll,fixed]"
    :next-alternative-text="i18n(translations.nextSlideText)"
    :prev-alternative-text="i18n(translations.prevSlideText)"
    :subtitle="
      isSmartphone
        ? i18n(translations.title)
        : i18n(translations.subtitleDynamic, {
            nb_points: categories?.checkpoints?.length,
          })
    "
    :title="i18n(translations.title)"
  >
    <Card
      v-for="(checkpoint, index) in categories?.checkpoints"
      :key="checkpoint.text.id"
      :checkpoint
      :index
    />
  </RevCardCarousel>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { categories as CHECKPOINTS_CATEGORIES_DATA } from '@backmarket/nuxt-layer-cms/BaseAnimatedProductCheckpoints/categories'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevCardCarousel } from '@ds/components/CardCarousel'

import { ProductCategory } from '../../constants'
import { CHECKPOINTS_CATEGORIES_MAPPING } from '../CheckpointsCarousel/CheckpointsCarousel.constants'

import translations from './VerifiedRefurbishedCarousel.translations'
import Card from './components/Card/Card.vue'

const { countryCode } = useMarketplace().market
const config = useRuntimeConfig()
const i18n = useI18n()

const props = defineProps<{
  categoryId: string
}>()

const categories = computed(() => {
  const checkpointsCategoriesMapping =
    CHECKPOINTS_CATEGORIES_MAPPING[props.categoryId]

  return checkpointsCategoriesMapping
    ? CHECKPOINTS_CATEGORIES_DATA[checkpointsCategoriesMapping]
    : null
})

const isSmartphone = computed(() => {
  return props.categoryId === ProductCategory.SMARTPHONE
})

const shouldDisplayBlock = computed(() => {
  return (
    categories.value &&
    categories?.value.checkpoints &&
    config.public.FF_ENABLE_VERIFIED_REFURBISHED_LINK_PP?.includes(countryCode)
  )
})
</script>
